/* eslint-disable */
const en = require('./pms-finder-en.json');
const de = require('./pms-finder-de.json');
const es = require('./pms-finder-es.json');
const fr = require('./pms-finder-fr.json');
const it = require('./pms-finder-it.json');
const pt = require('./pms-finder-pt.json');
export const prefix = 'pms-finder';
export default {
    en,
    de,
    es,
    fr,
    it,
    pt,
};
